import React from 'react'
import { useEffect, useState, useRef } from 'react'
import 'worldwindjs'
import PlaneDetails from './planes/PlaneDetails';
import ShipDetails from './ships/ShipDetails';
import EventDetails from './events/EventDetails';
import TargetDetails from './targets/TargetDetails';

/* global WorldWind */
const RenderablesLayer = (props) => {
    const { globe } = props
    const [isPlaneModalOpen, setIsPlaneModalOpen] = useState(false)
    const [isShipModalOpen, setIsShipModalOpen] = useState(false)
    const [isEventModalOpen, setIsEventModalOpen] = useState(false)
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false)

    const planeListRef = useRef([])
    const shipListRef = useRef([])
    const eventListRef = useRef([])
    const targetListRef = useRef([])

    const [plane, setPlane] = useState(null)
    const [ship, setShip] = useState(null)
    const [event, setEvent] = useState(null)
    const [target, setTarget] = useState(null)

    const handlePlaneModalShow = () => {
        setIsPlaneModalOpen(!isPlaneModalOpen)
    }
    const handleShipModalShow = () => {
        setIsShipModalOpen(!isShipModalOpen)
    }

    const handleEventModalShow = () => {
        setIsEventModalOpen(!isEventModalOpen)
    }

    const handleTargetModalShow = () => {
        setIsTargetModalOpen(!isTargetModalOpen)
    }
    const showPlane = (label) => {
        const planes = planeListRef.current
        for (let i = 0; i < planes.length; i++){ 
            if (label.includes(planes[i].plane.reg) || label.includes(planes[i].plane.icao)){             
                setPlane(planes[i].plane)
                handlePlaneModalShow()
                break
            }
        }
    }
    const showShip = (label) => {
        const ships = shipListRef.current
        for (let i = 0; i < ships.length; i++){ 
            if (label === ships[i].ship.shipName){             
                setShip(ships[i].ship)
                handleShipModalShow()
                break
            }
        }
    }

    const showEvent = (label) => {
        const events = eventListRef.current
        for (let i = 0;i < events.length; i++){ 
            if (parseInt(label) === events[i].event.id){    
                setEvent(events[i].event)   
                handleEventModalShow()      
                break
            }
        }
    }

    const showTarget = (label) => {
        const targets = targetListRef.current
        for (let i = 0;i < targets.length; i++){ 
            if (label === targets[i].target.chnName){    
                setTarget(targets[i].target)   
                handleTargetModalShow()  
                break
            }
        }
    }
    
    const handleClick = (o)=>{
        const {globe} = props
        var x = o.clientX,
            y = o.clientY;
        
        // 逐步增大拾取半径，已获取目标
        var rectRadius = -4;   
        var pickList     
        do{
            rectRadius += 5;
            var pickPoint = globe.wwd.canvasCoordinates(x, y),
            pickRectangle = new WorldWind.Rectangle(pickPoint[0] - rectRadius, pickPoint[1] + rectRadius,
                2 * rectRadius, 2 * rectRadius);
            pickList = globe.wwd.pickShapesInRegion(pickRectangle);
        }while(pickList.objects.length === 0 && rectRadius<27)

        if (pickList.objects.length > 0) {
            for (let i=0; i < pickList.objects.length; i++){
                if (pickList.objects[i].userObject.label && pickList.objects[i].userObject.label!==""){
                    const label = pickList.objects[i].userObject.label
                    const type = pickList.objects[i].userObject.type
                    if (type === 'plane') {
                        showPlane(label)
                    }
                    if (type === 'ship') {
                        showShip(label)
                    }
                    if (type === 'event') {
                        showEvent(label)
                    }
                    if (type === 'target') {
                        showTarget(label)
                    }
                    break
                }
            }
        }        
    }
    
    useEffect(() => {
        //处理点击事件
        if (globe) {
            new WorldWind.ClickRecognizer(globe.wwd, handleClick);
        }
    }, [globe])
    useEffect(() => {
        planeListRef.current = props.planes
        shipListRef.current = props.ships
        eventListRef.current = props.events
        targetListRef.current = props.targets
    }, [props.planes, props.ships, props.events, props.targets])
    return (
        <React.Fragment>
            {
                isPlaneModalOpen ?
                <PlaneDetails isModalOpen={isPlaneModalOpen} plane={plane} handleModalShow={handlePlaneModalShow}/> : ''
            }
            {
                isShipModalOpen ?
                <ShipDetails isModalOpen={isShipModalOpen} ship={ship} handleModalShow={handleShipModalShow}/> : ''
            }
            {
                isEventModalOpen ?
                <EventDetails isModalOpen={isEventModalOpen} event={event} handleModalShow={handleEventModalShow}/> : ''

            }
            {
                isTargetModalOpen ?
                <TargetDetails isModalOpen={isTargetModalOpen} target={target} handleModalShow={handleTargetModalShow}/> : ''
            }
        </React.Fragment>
    )
}

export default RenderablesLayer